// config.js
const config = {
  EHealth: {
    apiEndpoint: "https://data-ingestion.wadhwaniai.org/",
    bucketName: "ehealth-data-ingestion-bucket",
  },
  Agriculture: {
    apiEndpoint: "https://agri-collectpro.wadhwaniai.org/",
    bucketName: "agri-data-ingestion-bucket",
  },
  Punjab: {
    apiEndpoint: "https://dataharvestpunjab.wadhwaniai.org/",
    bucketName: "",
  },
  Dev: {
    apiEndpoint: "https://dev-dip.wadhwaniai.org/",
    bucketName: "data-ingestion-dev-bucket",
  },
  Seap: {
    apiEndpoint: "https://seap-data-ingestion.wadhwaniai.org/",
    bucketName: "seap-data-ingestion-bucket",
  },
  DevArgriGrn: {
    apiEndpoint: "https://dev-agri-grn-dip.wadhwaniai.org/",
    bucketName: "dev-agri-grain-collectpro-bucket",
    features: {
      QRCodeEnabled: true,
      locationLogging: true
    }
  },
  ProdArgriGrn: {
    apiEndpoint: "https://dip-prod-grn.wadhwaniai.org/",
    bucketName: "agri-grn-prod-dip-bucket",
    features: {
      QRCodeEnabled: true,
      locationLogging: true
    }
  },
  ProdAgriNpss: {
    apiEndpoint: "https://data-collection-prod-npss.wadhwaniai.org/",
    bucketName: "bucket-prod-npss-asso1-data-collection"
  },
};

export default config;
